<script src="main.js"></script>
<style lang="less">
/* 注入基本css */
@import "./styles/class.less";
@import "../common/styles/fontsize.less";
@import "../common/styles/func.less";
@import "./styles/color.less";

#app {
  min-width:1200px;
  margin: 0 auto;

}
*{
	-webkit-tap-highlight-color: rgba(0,0,0,0);
-webkit-tap-highlight-color: transparent;
}
.cgs-matching {
  margin-bottom: 20px;
}
</style>
<style lang="less" scoped>
.xbw-cover{
    background-image: url(./assets/images/vr/topback.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 30px 0 10px 0;
  }
</style>

<template>
  <div id="app">
    <div class="xbw-cover"  v-if="!$route.path.includes('register') && !$route.path.includes('exhibtArea') && !$route.path.includes('metaverse')">
      <nav-header></nav-header>
      <header-wrapper></header-wrapper>
    </div>
    <!-- class="padding-top-30" -->
    <div :class="!$route.path.includes('register') && !$route.path.includes('exhibtArea') && !$route.path.includes('metaverse') ? '': 'padding-top-30'"  style="position:relative;">
      <coolgua-container
        :class="[
        $route.path.indexOf('/login') > -1 ? 'bg':'',
        isShengzheng?'sz':(isEn?'redEn':'red'),
        (isShengzheng && isEn) ? 'szEn' : ''
      ]"
      >
        <keep-alive>
          <router-view v-if="$route&&$route.meta&&$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </coolgua-container>
    </div>
    <m-footer  v-if="!$route.path.includes('exhibtArea') && !$route.path.includes('metaverse')" :style="$route.path.indexOf('/login') > -1 ? 'margin-top: 0' : ''"></m-footer>

    <!--    推荐弹出框-->
    <recommendedPopup class="vue"></recommendedPopup>

    <!-- 直播承诺书弹出框 -->
    <commitmentLive></commitmentLive>
    <!--  技术支持-->
    <div
     v-if="!$route.path.includes('exhibtArea') && !$route.path.includes('metaverse')"
      @click="go2coolgua"
      style="display: flex;padding-left: 10px;padding-right: 10px;align-items: center;justify-content: center;margin-top: 20px;margin-bottom: 20px;"
    >
      <!--      <div class="lineleft" style="width:25%;height: 1px;color:#9E9E9E;background: #9E9E9E; "></div>-->
      <div
        style="font-size:12px;color: #9E9E9E;padding-left: 10px;padding-right: 10px;color:#9E9E9E;display: flex;align-items: center;"
      >
        <img src="https://xgyz.coolgua.com/icon/jishizhic2.png" style="width: 12px;height: 12px;" />
        <div class="pointer" style="margin-left: 5px;">Technical Support：Coolgua.苦瓜</div>
      </div>
      <!--      <div class="lineleft" style="width:25%;height: 1px;color:#9E9E9E;background: #9E9E9E;"></div>-->
    </div>
  </div>
</template>

<script>
import { injectTheme, setCookie, getLoginUser, getUrlParamNative } from '@common/utils';
import headerWrapper from "@wenxing/components/header2";
import navHeader from '@wenxing/components/navHeader';
import mFooter from '@wenxing/components/mfooter';
import { initTIM, eventlist, loginIM } from '@common/utils/imUtils.js'
import * as MessageStoreUtil from '@match/store/message/MessageStoreUtil';
import { createA, getCookie, uuid } from "../common/utils";
import * as indexStateUtil from '@match/pages/index/store/stateUtil'
import { isShengzheng, projectId_ } from "./constants";
import langEn_element from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import { setLangByUrl } from "./utils";
import minXin from "@/mixins/pageMixins"

window.document.oncontextmenu = function(){
	return false;
}
window.document.onselectstart = function(){
	  return false;
  }
document.onkeydown = document.onkeyup = document.onkeypress = function(event) {
    var e = event || window.event || arguments.callee.caller.arguments[0];
    if (e && e.keyCode == 123) {
        e.returnValue = false;
        return (false);
    }
}

export default {
  mixins:[minXin],
  name: 'App',
  components: {
    headerWrapper,
    "nav-header": navHeader,
    mFooter,
    "recommendedPopup": () => import('./components/recommendedPopup'),
    "commitmentLive": () => import('./components/commitmentLive')
  },
  data () {
    return {
      isShengzheng: isShengzheng,
      isEn: false,
    }
  },
  mounted () {
  },
  created () {
    //切换语言 ?lang=en
    this.getLangByUrl();
    //    注入主题
    injectTheme("blue_wenxing", '/pc')
    // injectTheme("red", '/pc')
    this.initFlow()
    indexStateUtil.action_init_flow();
  },
  methods: {
    go2coolgua () {
      createA('https://www.coolgua.com')
    },
    getLangByUrl () {
      var lang = setLangByUrl()
      if (!lang) {
        //如果路径没有 就从cookie拿
        lang = getCookie('lang')  || 'zh'
        sessionStorage.setItem('lang', lang)
      }
      setCookie("lang", lang)
      var isEn = lang == 'en'
      if (isEn) {
        this.$i18n.locale = 'en';//改变当前语言
        this.isEn = true;
        ELEMENT.locale(langEn_element)
      } else {
        this.$i18n.locale = 'zh';//改变当前语言
        this.isEn = false;
      }

    },
    initFlow () {
      //切换语言
      function GetQueryString (name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
      }

      //    进入系统在sessIOn获取登陆状态
      var currentUser = getLoginUser()
      //如果没有登陆想跳转到首页
      // if(!currentUser.id){
      //     // myalert.fail("检查到您没有登陆，请登陆后使用")
      //     // var redirect=encodeURIComponent(location.href)
      //     // if(location.href.indexOf(""))
      //     // replace(`/font/toLogin?projectId=${getProjectId()}&redirect=${redirect}`)
      //     return false
      // }
      if (currentUser && currentUser.id) {
        MessageStoreUtil.set_currentUser(currentUser)
      }
      // eventlist() //im event
      // this.$bus && this.$bus.$emit("eventBeforeLoginIM") //直播的监听先于登陆  loginIM
      // console.log("现在的登陆用户currentUser.id========>", currentUser.id || 'userDefault01')
      //游客，1.退出登录，2匿名登陆
      // if (!currentUser.id) {
      //   window.tim && window.tim.logout && window.tim.logout()
      // }
      // loginIM((currentUser.contactId || currentUser.id || uuid()) + "")
      //    修改projecetid
      setCookie("projectId", projectId_)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/wenxing/App.vue